export class RegisUser {
    UserID: string;
    MailAdress: string;
    Password: string;
    Name: string;
    KanaName: string;
    DateOfBirth: string;
    Gender: string;
    PhoneNum: string;
    PostalCode: string;
    Adress1: string;
    Adress2: string;
    RegistrationDiv: string;
    HTOrgName: string;
    CountryCode: string;
}
